"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeViewportReducer = void 0;
var constants_1 = require("./constants");
var utils_1 = require("./utils");
function makeViewportReducer(breakpoints, initialWidth, deviceMock) {
    var _a;
    if (breakpoints === void 0) { breakpoints = constants_1.defaultBreakpoints; }
    if (initialWidth === void 0) { initialWidth = Infinity; }
    if (deviceMock === void 0) { deviceMock = { orientation: '(orientation: portrait)' }; }
    var breakpointList = __assign(__assign({}, breakpoints), (_a = {}, _a[constants_1.infinityName] = Infinity, _a));
    var mediaQueries = utils_1.getMediaQueries(breakpointList);
    var initialState = calculateState(breakpointList, initialWidth, mediaQueries, deviceMock);
    return function (state, action) {
        if (state === void 0) { state = initialState; }
        if (action.type !== constants_1.CALCULATE_RESPONSIVE_STATE) {
            return state;
        }
        var innerWidth = action.payload.innerWidth;
        return calculateState(breakpointList, innerWidth, mediaQueries, deviceMock);
    };
}
exports.makeViewportReducer = makeViewportReducer;
exports.default = makeViewportReducer();
function calculateState(breakpoints, width, mediaQueries, deviceMock) {
    var mediaType = utils_1.getMediaType(width, mediaQueries);
    var orientation = utils_1.getOrientation(deviceMock);
    var is = utils_1.getIs(mediaType, breakpoints);
    var lessThan = utils_1.getLessThan(mediaType, breakpoints);
    var greaterThan = utils_1.getGreaterThan(mediaType, breakpoints);
    var lessThanOrEqual = utils_1.getBreakpointsWithEquality(mediaType, lessThan);
    var greaterThanOrEqual = utils_1.getBreakpointsWithEquality(mediaType, greaterThan);
    // build the responsive state
    return {
        _responsiveState: true,
        lessThan: lessThan,
        greaterThan: greaterThan,
        is: is,
        mediaType: mediaType,
        orientation: orientation,
        breakpoints: breakpoints,
        greaterThanOrEqual: greaterThanOrEqual,
        lessThanOrEqual: lessThanOrEqual,
    };
}
//# sourceMappingURL=reducer.js.map